import { PropTypes } from "prop-types";

import studentDisplayName from "../../utils/studentDisplayName";
import T from "../translations/Translations";

const DisplaySemester = ({ epr }) => {
    const { gradingProfileComment, gradingProfileStudentComment, studentName } = epr;

    if (!gradingProfileComment && !gradingProfileStudentComment) {
        return null;
    }

    return (
        <div className="semester-container">
            <div className="semester-title">
                {epr.semester} {T({ key: "Semester_Overall" })}
            </div>
            <div className="semester-message">
                {gradingProfileComment && (
                    <div className="message-container">
                        <div className="message-container-title">{T({ key: "Semester_Comment_All" })}:</div>
                        <div className="message-container-body">{gradingProfileComment}</div>
                    </div>
                )}
                {gradingProfileStudentComment && (
                    <div className="message-container">
                        <div className="message-container-title">
                            {studentDisplayName(studentName)}&apos;s {T({ key: "Semester_Comment_Student" })}:
                        </div>
                        <div className="message-container-body">{gradingProfileStudentComment}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

DisplaySemester.propTypes = {
    epr: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default DisplaySemester;
